/* @jsx h */

const Event = ({ result }) => {
  return (
    <li className="search-result__item">
      <article className="search-result-item">
        <header className="search-result-item__header">
          <div className="search-result-item__meta">
            {result.eventType && (
              <span
                className={`search-result-item__tag ${
                  result.eventType === 'Externe Veranstaltung'
                    ? 'search-result-item__tag--external'
                    : result.eventType === 'meta-IFiF'
                    ? 'search-result-item__tag--meta-ifif'
                    : 'search-result-item__tag--ifif-project'
                }`}
              >
                {result.eventType}
              </span>
            )}
            {!result.eventType && (
              <span className="search-result-item__type">
                {result.contentType}
              </span>
            )}
            {result.location && (
              <span className="search-result-item__location">
                {result.location}
              </span>
            )}
            {result.dateFormatted && (
              <span className="search-result-item__date">
                <time datetime={result.datetime}>{result.dateFormatted}</time>
                {!!result.endDateFormatted && (
                  <span>
                    &nbsp;<span className="sr-only">bis</span>
                    <span aria-hidden="true">-</span>&nbsp;
                  </span>
                )}
                {!!result.endDateFormatted && (
                  <time datetime={result.endDatetime}>
                    {result.endDateFormatted}
                  </time>
                )}
              </span>
            )}
            {result.eventFormat && (
              <span className="search-result-item__format">
                {result.eventFormat}
              </span>
            )}
          </div>
          <h3 className="search-result-item__heading">
            <a className="search-result-item__link" href={result.url}>
              {result.title}
            </a>
          </h3>
        </header>
        <div className="search-result-item__content">
          <div className="text-content">
            {result.teaser && <p>{result.teaser}</p>}
          </div>
        </div>
      </article>
    </li>
  );
};

export default Event;
